export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4840.db23c971.jpg";